import RectangleBlock from "../block/RectangleBlock.jsx";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../../constants/colors";

const RaceForward = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  return (
    <group position={position} rotation={rotation}>
      <RigidBody type="fixed" friction={1} restitution={0} ccd={false}>
        <mesh>
          <boxGeometry args={[6, 0.01, 6]} />
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </mesh>
      </RigidBody>
      <RectangleBlock position={[2.8, 0.6, 0]} />
      <RectangleBlock position={[-2.8, 0.6, 0]} />
    </group>
  );
};

export default RaceForward;
